// extracted by mini-css-extract-plugin
export var backdrop = "styles-module--backdrop--3nSRz";
export var isScrolling = "styles-module--is-scrolling--2e829";
export var header = "styles-module--header--1nv0f";
export var logoWrap = "styles-module--logo-wrap--3J7fb";